<template>
  <div class="custom-select" @click="toggleDropdown">
    <div class="custom-select__header"><p>{{ selectedText }}</p> <NuxtImg src="/img/icon_arrow_down.svg" class="arrow" :class="{open: isOpen}"/></div>
    <ul ref="dropdownList" class="custom-select__list" :class="{open: isOpen}">
      <li v-for="(option) in options" @click.stop="toggleSelection(option)" :key="option.id" class="custom-select__item">
        <div class="custom-checkbox">
          <div class="custom-checkbox__box"><NuxtImg v-if="isSelected(option)" src="/img/icon_checked.svg"/></div>
          <span class="custom-checkbox__label">{{ option.attributes.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  maxSelections: {
    type: Number,
    default: 1,
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  placeholder: String
});

const emit = defineEmits(['update:modelValue', 'change'])
const selectedOptions = ref([...props.modelValue]);
const isOpen = ref(false);
const dropdownList = ref(null);

const toggleDropdown = (event) => {
  isOpen.value = !isOpen.value;
  event.stopPropagation();
};

const handleClickOutside = (event) => {
  if (dropdownList.value && !dropdownList.value.contains(event.target)) {
    isOpen.value = false;
  }
};

const toggleSelection = (option) => {
  if (isSelected(option)) {
    selectedOptions.value = selectedOptions.value.filter(selected => selected.id !== option.id);
  } else if (selectedOptions.value.length < props.maxSelections) {
    selectedOptions.value.push(option);
  }
  emit('update:modelValue', selectedOptions.value);
  emit('change', selectedOptions.value)
};

const isSelected = (option) => {
  return selectedOptions.value.some(selected => selected.id === option.id);
};

const selectedText = computed(() => {
  return selectedOptions.value.map(option => option.attributes.name).join(', ') || props.placeholder;
});

watch(() => props.modelValue, (newVal) => {
  selectedOptions.value = [...newVal];
});

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped lang="scss">
.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  border-radius: 6px;

  &__header {
    background-color: #fff;
    cursor: pointer;
    user-select: none;
    height: 81px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px;
    font-size: 12px;
    border-radius: 6px;
    .arrow {
      height: 10px;
      transition: .2s;
      &.open {
      transform: rotate(-180deg);
      }
    }

    p {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      @media screen and (max-width: 460px) {
        font-size: 16px;
      }
    }
  }

  &__list {
    position: absolute;
    width: 100%;
    max-height: 468px;
    overflow-y: auto;
    background-color: #fff;
    z-index: 1000;
    display: none;
    flex-direction: column;
    gap: 20px;
    padding: 0 32px 32px;
    &.open {
      display: flex;
    }
  }

  @include sm {
    &__header {
      height: 60px;
      padding: 18px 20px;
    }
    &__list {
      padding: 18px 20px;
    }
  }

  &__item {
    cursor: pointer;
    &:hover {
      background-color: #f0f0f0;
    }
  }
}

.custom-checkbox {
  display: grid;
  grid-template-columns: 16px 1fr;
  align-items: center;
  gap: 8px;
  &__box {
    width: 16px;
    height: 16px;
    border: 1px solid #ccc;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 7px;
    }
  }

  &__label {
    cursor: pointer;

    @include sm {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
